export const AVATAR_CONTAINER_HEIGHT = 274;
